import { useSelector } from 'react-redux';

import { EntityBlockedReasonsResponse } from 'app/modules/entities/responses';
import { selectHasReadEntitiesPermissions } from 'app/modules/session/selectors';

import { ENTITY_QUERY_KEYS } from 'app/modules/entities/queries/keys';

import { get } from 'app/shared/utils/fetchr';
import { useQuery } from '@tanstack/react-query';
import { useHashedId } from 'app/shared/hooks/useHashedId';

export const useGetBlockedReasons = (entityExternalId: string) => {
  const hasReadEntitiesPermission = useSelector(
    selectHasReadEntitiesPermissions,
  );
  const { hashedId: entityHashedId, useHashed } =
    useHashedId(entityExternalId);
  return useQuery({
    queryFn: () =>
      useHashed
        ? get<EntityBlockedReasonsResponse>(
            `/v1/entities/cached/${encodeURIComponent(entityHashedId)}/entity-blocked-reasons`,
          )
        : get<EntityBlockedReasonsResponse>(
            `/v1/entities/${encodeURIComponent(entityExternalId || '')}/entity-blocked-reasons`,
          ),
    queryKey: ENTITY_QUERY_KEYS.getEntityBlockedReasons(
      useHashed ? entityHashedId : entityExternalId,
    ),
    staleTime: 10000,
    enabled: hasReadEntitiesPermission && !!entityExternalId,
  });
};
